export default "__VITE_ASSET__YBc1RuR$__"